import { render } from "./ModalSuccess.vue?vue&type=template&id=89ceb368&scoped=true&ts=true"
import script from "./ModalSuccess.vue?vue&type=script&lang=ts"
export * from "./ModalSuccess.vue?vue&type=script&lang=ts"

import "./ModalSuccess.vue?vue&type=style&index=0&id=89ceb368&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89ceb368"]])

export default __exports__